import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AngularFireAuthGuard, redirectUnauthorizedTo} from '@angular/fire/compat/auth-guard';

import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {StartupComponent} from './components/startup/startup.component';
import {SettingsComponent} from './components/settings/settings.component';
import {HomeDeliveryDetailsComponent} from './components/home-delivery-details/home-delivery-details.component';
import {TransportDetailsComponent} from './components/transport-details/transport-details.component';
import {TransportPlanComponent} from './components/transport-plan/transport-plan.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['/login']);

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'startup',
    component: StartupComponent,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'home-delivery-details',
    component: HomeDeliveryDetailsComponent,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'transport-details',
    component: TransportDetailsComponent,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'transport-plan',
    component: TransportPlanComponent,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: '**',
    redirectTo: '/startup'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
